export default function FilterOffers() {
  const cityCheckboxes = document.querySelectorAll('#city-filters input')
  const deptCheckboxes = document.querySelectorAll('#dept-filters input')
  const jobItems = document.querySelectorAll('.job-item')

  if (cityCheckboxes.length === 0 && deptCheckboxes.length === 0) {
    return
  }

  if (jobItems.length === 0) {
    return
  }

  function updateSpanWidth() {
    const buttonApply = document.querySelector('a.button-apply.item-3')
    const targetSpan = document.querySelector('span.item-3')

    if (buttonApply && targetSpan) {
      const buttonWidth = buttonApply.offsetWidth
      targetSpan.style.width = buttonWidth + 'px'
    }
  }
  updateSpanWidth()

  function updateCounts() {
    const cityCounts = {}
    const deptCounts = {}

    const cityLabels = document.querySelectorAll('#city-filters .checkbox-item')
    const deptLabels = document.querySelectorAll('#dept-filters .checkbox-item')

    cityCheckboxes.forEach((cb) => {
      const value = cb.value.toLowerCase()
      if (value !== 'all') {
        cityCounts[value] = 0
      }
    })

    deptCheckboxes.forEach((cb) => {
      const value = cb.value.toLowerCase()
      if (value !== 'all') {
        deptCounts[value] = 0
      }
    })

    jobItems.forEach((item) => {
      if (item.classList.contains('hidden')) {
        return
      }

      const city = item.getAttribute('data-city').toLowerCase()
      const dept = item.getAttribute('data-dept').toLowerCase()

      if (cityCounts.hasOwnProperty(city)) {
        cityCounts[city]++
      }

      if (deptCounts.hasOwnProperty(dept)) {
        deptCounts[dept]++
      }
    })

    const updateLabels = (labels, counts) => {
      const totalVisible = Array.from(jobItems).filter(
        (item) => !item.classList.contains('hidden')
      ).length

      labels.forEach((label) => {
        const input = label.querySelector('input')
        const value = input ? input.value.toLowerCase() : null
        let countSpan = label.querySelector('.job-count')

        if (!countSpan) {
          countSpan = document.createElement('span')
          countSpan.className = 'job-count'
          label.appendChild(countSpan)
        }

        if (value === 'all') {
          countSpan.textContent = ` (${totalVisible})`
        } else if (counts.hasOwnProperty(value)) {
          countSpan.textContent = ` (${counts[value]})`
        } else {
          countSpan.textContent = ''
        }
      })
    }

    updateLabels(cityLabels, cityCounts)

    updateLabels(deptLabels, deptCounts)
  }

  function handleCheckboxLogic(checkbox, groupNodeList) {
    const allCheckbox = groupNodeList[0]
    const otherCheckboxes = Array.from(groupNodeList).slice(1)

    if (checkbox.value === 'all') {
      if (checkbox.checked) {
        otherCheckboxes.forEach((cb) => (cb.checked = false))
      } else {
        checkbox.checked = true
      }
    } else {
      if (checkbox.checked) {
        allCheckbox.checked = false
      } else {
        const anyChecked = otherCheckboxes.some((cb) => cb.checked)
        if (!anyChecked) {
          allCheckbox.checked = true
        }
      }
    }

    filterJobs()
  }

  function filterJobs() {
    const getActiveValues = (nodeList) => {
      const allCb = nodeList[0]
      if (allCb.checked) return null

      return Array.from(nodeList)
        .slice(1)
        .filter((cb) => cb.checked)
        .map((cb) => cb.value)
    }

    const rawActiveCities = getActiveValues(cityCheckboxes)
    const rawActiveDepts = getActiveValues(deptCheckboxes)

    const activeCities = rawActiveCities
      ? rawActiveCities.map((city) => city.toLowerCase())
      : null

    const activeDepts = rawActiveDepts
      ? rawActiveDepts.map((dept) => dept.toLowerCase())
      : null

    const currentlyVisibleItems = []

    jobItems.forEach((item) => {
      const itemCity = item.getAttribute('data-city').toLowerCase()
      const itemDept = item.getAttribute('data-dept').toLowerCase()

      const cityMatch = activeCities === null || activeCities.includes(itemCity)
      const deptMatch = activeDepts === null || activeDepts.includes(itemDept)

      if (cityMatch && deptMatch) {
        item.classList.remove('hidden')
        item.classList.remove('anim-in')
        void item.offsetWidth
        item.classList.add('anim-in')
        currentlyVisibleItems.push(item)
      } else {
        item.classList.add('hidden')
        item.classList.remove('anim-in')
      }
    })
  }

  cityCheckboxes.forEach((cb) => {
    cb.addEventListener('change', () => handleCheckboxLogic(cb, cityCheckboxes))
  })

  deptCheckboxes.forEach((cb) => {
    cb.addEventListener('change', () => handleCheckboxLogic(cb, deptCheckboxes))
  })

  filterJobs()
  updateCounts()
}
